import { EXPECT } from "@/data/content";
import Reveal from "@/components/Reveal";
import { Mic, Wrench, Presentation, Rocket, Code2, FlaskConical, Users, Music } from "lucide-react";

const ICONS = [Mic, Wrench, Presentation, Rocket, Code2, FlaskConical, Users, Music];

export default function WhatToExpect() {
  return (
    <section id="expect" className="py-24 sm:py-32 px-5 sm:px-8 lg:px-12 bg-paper">
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.22em] text-crimson font-semibold mb-5">03 · What to Expect</p>
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter leading-[0.95] max-w-3xl">
            More than talks. A three-day biotech experience.
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-ink/10 border border-ink/10">
          {EXPECT.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={item.title} delay={(i % 4) * 0.06}>
                <div className="group bg-paper hover:bg-white p-7 h-full transition-colors min-h-[200px] flex flex-col">
                  <Icon size={26} className="text-crimson mb-5" strokeWidth={1.6} />
                  <h3 className="font-heading text-xl font-semibold tracking-tight">{item.title}</h3>
                  <p className="mt-2 text-ink/65 text-[15px] leading-relaxed">{item.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
